// extracted by mini-css-extract-plugin
module.exports = {"sharePopover":"aj","shareText":"ak","show":"al"};